module.exports = __webpack_public_path__ + "img/winerack00.20406068.jpg";